import { RouteRecordRaw } from 'vue-router';
import { SectionRouteNames } from './sectionRouteNames.ts';

export const flexibilityRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.flexibility}Home`,
        components: {
            default: () => import('@/views/sectionViews/flexibility/FlexibilityHomeView.vue'),
        },
        meta: {
            headName: 'Flexibility Home',
            displayTitle: 'Home',
        },
    },
    enact: {
        path: 'enact',
        name: `${SectionRouteNames.flexibility}Enact`,
        redirect: { name: 'EV Flexibility Index' },
        meta: {
            headName: 'Enact',
            displayTitle: 'Enact',
            showChildrenInNavbar: true,
            showChildrenInNavDropdown: true,
            searchMeta: {
                noSearch: true,
            },
        },
        children: [
            {
                path: 'ev-flexibility-index',
                name: `${SectionRouteNames.flexibility}EvFlexibilityIndex`,
                redirect: { name: 'EV Flexibility Index' },
                meta: {
                    headName: 'EV Flexibility Index',
                    searchMeta: {
                        noSearch: true,
                    },
                },
            },
        ],
    },
};
